import React from 'react';
import { business, images } from '../data/business';
interface LogoProps {
  size?: 'navbar' | 'footer';
}
export function Logo({
  size = 'navbar'
}: LogoProps) {
  const heightClass = size === 'navbar' ? 'h-10 sm:h-12 lg:h-14' : 'h-10 sm:h-11 lg:h-12';
  return <a href="#home" className="inline-flex shrink-0 items-center py-1" data-id="element-245" data-mp="3q7qi1pxirkkx">
      <img src={images.logo} alt={`${business.name} — professional cleaning in Houston, Texas`} className={`${heightClass} w-auto object-contain`} data-id="element-246" data-mp="3v8xnvjg3q9oy" />
    </a>;
}